import { Injectable } from '@angular/core';
import { HttpInterceptor, HttpHandler, HttpRequest, HttpEvent } from '@angular/common/http';
import { Observable } from 'rxjs';
import { finalize } from 'rxjs/operators';
import { LoadingService } from '../services/loading.service';

@Injectable()
export class LoadingInterceptor implements HttpInterceptor {
  constructor(private loadingService: LoadingService) { }

  intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    if (req.headers.has('Globalloading') && req.headers.get('Globalloading') == 'true') {
        this.loadingService.showLoading();
      }
    return next.handle(req).pipe(
      finalize(() => {
        if (req.headers.has('Globalloading') && req.headers.get('Globalloading') == 'true') {
            this.loadingService.hideLoading();
          }
      })
    );
  }
}
